<template>
    <v-dialog
        v-model="changeModal"
        v-if="changeModal"
        persistent
        max-width="1000"
    >
        <validation-observer v-slot="{ handleSubmit }">
            <div class="change-rank-wrapper">
                <div class="change-rank-header">
                    <span class="change-rank-name">
                        CHỌN LỘ TRÌNH LÀM VIỆC
                    </span>
                    <v-icon
                        size="24"
                        @click="closeModal"
                    >
                        mdi-close
                    </v-icon>
                </div>
                <div class="change-rank-form">
                    <v-row>
                        <v-col cols="4" class="pl-0">
                            <v-autocomplete
                                v-model="ministryId"
                                :items="listMinistry"
                                item-text="name"
                                item-value="id"
                                label="Bộ phận"
                                hide-details
                                @change="getOrgChild()"
                            />
                        </v-col>
                        <template v-for="(listOrg, index) in listOrgs">
                            <v-col cols="4" class="pl-0" :key="index" v-if="listOrg.length">
                                <v-autocomplete
                                    v-model="orgIds[index].orgId"
                                    :items="listOrg"
                                    item-text="name"
                                    item-value="id"
                                    label="Nhánh"
                                    prepend-inner-icon="mdi-chevron-right"
                                    hide-details
                                    @change="getOrgChild(orgIds[index].orgId, orgIds[index].id)"
                                />
                            </v-col>
                        </template>
                    </v-row>
                    <v-row v-show="listRank.length">
                        <v-col cols="12" class="pl-0">
                            <validation-provider
                                v-slot="{ errors }"
                                class="mb-2"
                                rules="required"
                                name="Rank"
                            >
                                <v-autocomplete
                                    v-model="rankId"
                                    :items="listRank"
                                    item-text="name"
                                    item-value="id"
                                    label="Lộ trình làm việc"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                </div>
                <div class="col text-center">
                    <button
                        class="cancel-btn"
                        @click="closeModal"
                    >
                        BỎ QUA
                    </button>
                    <button
                        class="accept-btn"
                        @click="handleSubmit(updateRank)"
                    >
                        LƯU
                    </button>
                </div>
            </div>
        </validation-observer>
    </v-dialog>
</template>

<script>
import moment from 'moment'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const organizationMachine = RepositoryFactory.get('organization_machine')
export default {
    props: {
        changeModal: {
            type: Boolean,
            default: false
        },
        allowChangeRank: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            ministryId: '',
            orgIds: [],
            rankId: '',
            listMinistry: [],
            listOrgs: [],
            listRank: []
        }
    },

    created() {
        this.getMinistry()

        Bus.$on('reset-change-rank-path', () => {
            this.ministryId = ''
            this.orgIds = []
            this.rankId = ''
            this.listOrgs = []
            this.listRank = []
        })
    },

    beforeDestroy() {
        Bus.$off('reset-change-rank-path')
    },

    methods: {
        closeModal() {
            Bus.$emit('close-change-rank-modal')
        },

        async getMinistry() {
            const res = await organizationMachine.listMinistryOnly()

            if (res.success) {
                this.listMinistry = _.get(res, 'data', [])
            } else {
                this.listMinistry = []
            }
        },

        async getOrgChild(parentId, id) {
            if (parentId) {
                let index = this.orgIds.findIndex(o => o.id == id) 

                if (index > -1) {
                    this.listOrgs.splice(index + 1)
                    this.orgIds.splice(index + 1)
                }
            } else {
                this.listOrgs = []
                this.orgIds = []
            }
            const res = await organizationMachine.childOrg({
                ministryId: this.ministryId,
                parentId
            })

            if (res.success) {
                this.orgIds.push({
                    id: moment().unix(),
                    orgId: ''
                })
                this.listOrgs.push(_.get(res, 'data.children', []))
                this.listRank = _.get(res, 'data.ranks', [])
            } else {
                this.listRank = []
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
            }
        },

        updateRank() {
            if (this.allowChangeRank) {
                Bus.$emit('action-change-rank')
                Bus.$emit('change-rank-user', this.rankId)
            }
        }
    }
}
</script>

<style scoped>
.change-rank-wrapper {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
}

.change-rank-header {
    padding: 15px 0px;
    margin: 0px 20px 0px 30px;
    border-bottom: 1px solid #E0E0E0;
}

.change-rank-header i {
    float: right;
    cursor: pointer;
}

.change-rank-name {
    font-size: 20px;
    font-weight: 600;
}

/deep/ .row {
    margin: 0px 20px 0px 30px;
}

.cancel-btn {
    background-color: #F2F2F2;
    width: 150px;
    height: 48px;
    font-size: 16px;
    color: #828282;
    font-weight: 700;
    border-radius: 8px;
    margin-right: 24px;
}

.accept-btn {
    background-color: #7367F0;
    width: 150px;
    height: 48px;
    font-size: 16px;
    color: white;
    font-weight: 700;
    border-radius: 8px;
}
</style>